import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { PERMISSIONS } from "../utils/permissions";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import Pagination from "../components/Pagination";
import "./EmployeePermissionPanel.css";

const P = PERMISSIONS;

export const PERMISSION_CATALOG = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "solar:widget-2-linear",
    items: [
      {
        id: "dashboard",
        label: "Dashboard",
        hint: "Home overview and widgets",
        view: [P.DASHBOARD],
      },
    ],
  },
  {
    id: "walkins",
    label: "Walk-Ins",
    icon: "solar:users-group-rounded-linear",
    items: [
      {
        id: "walkins",
        label: "Walk-Ins",
        hint: "Customer arrival desk",
        view: [P.CUSTOMER_ARRIVAL, P.TEST_CUSTOMER_FORM],
      },
      {
        id: "customer-assign",
        label: "Customer Assign",
        hint: "Assign walk-ins to staff",
        view: [P.CUSTOMER_ASSIGN],
      },
      {
        id: "order-queue",
        label: "Order Queue",
        hint: "Work queue for open orders",
        view: [P.ORDER_QUEUE],
      },
    ],
  },
  {
    id: "hrms",
    label: "HRMS",
    icon: "solar:case-linear",
    items: [
      {
        id: "hrms-holidays",
        label: "Holidays",
        hint: "Holiday calendar",
        view: [P.HRMS_HOLIDAY_VIEW],
        edit: [P.HRMS_HOLIDAY_VIEW, P.HRMS_HOLIDAY_EDIT],
      },
      {
        id: "hrms-profiles",
        label: "Payroll Profiles",
        hint: "Employee payroll setup",
        view: [P.HRMS_PROFILE_VIEW],
        edit: [P.HRMS_PROFILE_VIEW, P.HRMS_PROFILE_EDIT],
      },
      {
        id: "hrms-attendance",
        label: "Attendance",
        hint: "Daily attendance records",
        view: [P.HRMS_ATTENDANCE_VIEW],
        edit: [P.HRMS_ATTENDANCE_VIEW, P.HRMS_ATTENDANCE_EDIT],
      },
      {
        id: "hrms-incentives",
        label: "Incentives",
        hint: "Incentive entries",
        view: [P.HRMS_INCENTIVE_VIEW],
        edit: [P.HRMS_INCENTIVE_VIEW, P.HRMS_INCENTIVE_EDIT],
      },
    ],
  },
  {
    id: "sales-targets",
    label: "Sales targets",
    icon: "solar:graph-up-linear",
    items: [
      {
        id: "sales-target",
        label: "Sales Target",
        hint: "Branch and staff targets",
        view: [P.SALES_TARGET_VIEW],
        edit: [P.SALES_TARGET_VIEW, P.SALES_TARGET_EDIT],
      },
    ],
  },
  {
    id: "orders",
    label: "Orders",
    icon: "solar:bag-3-linear",
    items: [
      {
        id: "purchase",
        label: "Purchase",
        hint: "Purchase bills and table",
        view: [P.SALES, P.PURCHASE_TABLE],
        edit: [P.SALES, P.PURCHASE_TABLE, P.ADD_PURCHASE, P.EDIT_PURCHASE],
      },
      {
        id: "old-purchase",
        label: "Old Metal Purchase",
        hint: "URD / old metal buying",
        view: [P.METAL_PURCHASE_TABLE],
        edit: [
          P.METAL_PURCHASE_TABLE,
          P.ADD_OLD_PURCHASE,
          P.EDIT_OLD_PURCHASE,
          P.OLD_PURCHASE_PDF,
        ],
      },
      {
        id: "invoice",
        label: "Invoice / Sales",
        hint: "Sales invoices",
        view: [P.INVOICE],
        edit: [P.INVOICE, P.EDIT_INVOICE],
      },
      {
        id: "custom-order",
        label: "Custom Order",
        hint: "Made-to-order jobs",
        view: [P.CUSTOM_ORDER_ENTRY_TABLE],
        edit: [
          P.CUSTOM_ORDER_ENTRY_TABLE,
          P.CUSTOM_ORDER_ENTRY,
          P.EDIT_CUSTOM_ORDER_ENTRY,
        ],
      },
      {
        id: "repairing",
        label: "Repairing Order",
        hint: "Repair tickets",
        view: [P.REPAIRING_ORDER],
        edit: [
          P.REPAIRING_ORDER,
          P.REPAIRING_ORDER_ENTRY,
          P.EDIT_REPAIRING_ORDER,
          P.REPAIRING_SALES,
        ],
      },
      {
        id: "jangad",
        label: "Jangad",
        hint: "Issue / return slips",
        view: [P.JANGAD],
        edit: [P.JANGAD, P.ADD_JANGAD, P.EDIT_JANGAD],
      },
    ],
  },
  {
    id: "products",
    label: "Products",
    icon: "solar:box-linear",
    items: [
      {
        id: "stock",
        label: "Stock",
        hint: "Tagged stock and bulk stock",
        view: [P.STOCK_TABLE],
        edit: [P.STOCK_TABLE, P.STOCK, P.EDIT_STOCK, P.BULK_STOCK],
      },
    ],
  },
  {
    id: "party",
    label: "Party",
    icon: "solar:user-id-linear",
    items: [
      {
        id: "customer",
        label: "Customer",
        hint: "Customer master",
        view: [P.CUSTOMER],
      },
      {
        id: "supplier",
        label: "Supplier / Karigar",
        hint: "Supplier and karigar master",
        view: [P.SUPPLIER, P.KARIGAR, P.SUPPLIER_TABLE],
      },
    ],
  },
  {
    id: "item-groups",
    label: "Item Groups",
    icon: "solar:layers-linear",
    items: [
      {
        id: "metal-group",
        label: "Metal Group",
        view: [P.METAL_GROUP],
      },
      {
        id: "item-category",
        label: "Item Category",
        view: [P.ITEM_CATEGORY],
      },
      {
        id: "product-group",
        label: "Product Group",
        view: [P.PRODUCT_GROUP],
      },
      {
        id: "product-assorting",
        label: "Product Assorting",
        hint: "Core product assorting",
        view: [P.PRODUCT_ASSORTING_TABLE],
        edit: [P.PRODUCT_ASSORTING_TABLE, P.PRODUCT_ASSORTING],
      },
    ],
  },
  {
    id: "shop-expense",
    label: "Shop expense",
    icon: "solar:wallet-money-linear",
    items: [
      {
        id: "shop-expense",
        label: "Shop Expense",
        hint: "Operating expenses",
        view: [P.SHOP_EXPENSE_TABLE],
        edit: [P.SHOP_EXPENSE_TABLE, P.ADD_SHOP_EXPENSE, P.EDIT_SHOP_EXPENSE],
      },
    ],
  },
  {
    id: "setup",
    label: "Setup",
    icon: "solar:settings-linear",
    items: [
      {
        id: "bill-type",
        label: "Bill Type",
        view: [P.BILL_TYPE],
      },
      {
        id: "bank",
        label: "Bank",
        view: [P.BANK],
      },
      {
        id: "daily-price",
        label: "Daily Price",
        hint: "Gold and silver rates",
        view: [P.DAILY_PRICE],
      },
      {
        id: "employee",
        label: "Employee",
        hint: "Staff list and this permissions screen",
        view: [P.EMPLOYEE],
      },
      {
        id: "capital",
        label: "Capital Investment",
        view: [P.CAPITAL_INVESTMENT_TABLE],
        edit: [P.CAPITAL_INVESTMENT_TABLE, P.EDIT_CAPITAL_INVESTMENT],
      },
      {
        id: "tenant",
        label: "Tenant",
        view: [P.TENANT_TABLE],
        edit: [P.TENANT_TABLE, P.EDIT_TENANT],
      },
      {
        id: "branch",
        label: "Branch",
        view: [P.BRANCH_TABLE],
        edit: [P.BRANCH_TABLE, P.EDIT_BRANCH],
      },
    ],
  },
  {
    id: "dihran",
    label: "Dihran",
    icon: "solar:safe-2-linear",
    items: [
      {
        id: "settlement",
        label: "Customer Settlement",
        hint: "Add cash / metal settlement",
        view: [P.ADD_SETTLEMENT],
      },
      {
        id: "dihran",
        label: "Dihran",
        hint: "Dashboard, list, add and edit",
        view: [P.GIRVI, P.GIRVITABLE],
        edit: [P.GIRVI, P.GIRVITABLE, P.ADDGIRVI, P.EDITGIRVI],
      },
      {
        id: "dihran-payment",
        label: "Quick Payment",
        view: [P.GIRVIQUICKPAYMENT],
      },
      {
        id: "dihran-bank",
        label: "Bank Details",
        view: [P.GIRVIBANKDETAILS],
      },
      {
        id: "dihran-ledger",
        label: "Bank Ledger",
        view: [P.GIRVIBANKLEDGER],
      },
    ],
  },
  {
    id: "reports",
    label: "Reports",
    icon: "solar:document-text-linear",
    items: [
      {
        id: "overall-ledger",
        label: "Overall Ledger",
        view: [P.OVERALL_LEDGER],
      },
      { id: "rojmel", label: "Rojmel", view: [P.ROJMEL_VIEW] },
      { id: "bank-ledger", label: "Bank Ledger", view: [P.BANK_LEDGER] },
      {
        id: "karigar-ledger",
        label: "Karigar Ledger",
        view: [P.KARIGAR_LEDGER],
      },
      {
        id: "customer-ledger",
        label: "Customer Ledger",
        view: [P.CUSTOMER_LEDGER],
      },
      {
        id: "purchase-ledger",
        label: "Purchase Ledger",
        view: [P.PURCHASE_LEDGER],
      },
      { id: "sales-ledger", label: "Sales Ledger", view: [P.SALES_LEDGER] },
      { id: "urd-ledger", label: "URD Ledger", view: [P.URD_LEDGER] },
    ],
  },
];

function editOnlyKeys(item) {
  const view = item.view || [];
  return (item.edit || []).filter((key) => !view.includes(key));
}

function setPermissionKeys(permissions, keys, value) {
  if (!keys.length) return permissions;
  const next = { ...permissions };
  keys.forEach((key) => {
    next[key] = value;
  });
  if (keys.includes(P.SUPPLIER) || keys.includes(P.KARIGAR)) {
    next[P.SUPPLIER] = value;
    next[P.KARIGAR] = value;
  }
  return next;
}

function getItemAccess(permissions, uiFlags, item) {
  const extra = uiFlags[item.id] || {};
  const editKeys = editOnlyKeys(item);
  const removeKeys = item.remove || [];
  return {
    view: (item.view || []).some((key) => permissions[key]),
    edit: editKeys.length
      ? editKeys.some((key) => permissions[key])
      : Boolean(extra.edit),
    delete: removeKeys.length
      ? removeKeys.some((key) => permissions[key])
      : Boolean(extra.delete),
  };
}

function toggleItemAccess(permissions, uiFlags, item, flag) {
  const extra = uiFlags[item.id] || {};
  const current = getItemAccess(permissions, uiFlags, item);
  const nextVal = !current[flag];
  let nextPerms = permissions;
  let nextUi = uiFlags;

  if (flag === "view") {
    nextPerms = setPermissionKeys(permissions, item.view || [], nextVal);
  } else if (flag === "edit") {
    const keys = editOnlyKeys(item);
    if (keys.length) {
      nextPerms = setPermissionKeys(permissions, keys, nextVal);
    } else {
      nextUi = { ...uiFlags, [item.id]: { ...extra, edit: nextVal } };
    }
  } else if (flag === "delete") {
    const keys = item.remove || [];
    if (keys.length) {
      nextPerms = setPermissionKeys(permissions, keys, nextVal);
    } else {
      nextUi = { ...uiFlags, [item.id]: { ...extra, delete: nextVal } };
    }
  }

  return { permissions: nextPerms, uiFlags: nextUi };
}

function setItemAllAccess(permissions, uiFlags, item, nextVal) {
  let nextPerms = permissions;
  let nextUi = uiFlags;
  ["view", "edit", "delete"].forEach((flag) => {
    const current = getItemAccess(nextPerms, nextUi, item);
    if (Boolean(current[flag]) === Boolean(nextVal)) return;
    const result = toggleItemAccess(nextPerms, nextUi, item, flag);
    nextPerms = result.permissions;
    nextUi = result.uiFlags;
  });
  return { permissions: nextPerms, uiFlags: nextUi };
}

function AccessCheckbox({ id, checked, disabled, label, caption, onChange }) {
  return (
    <Form.Check
      type="checkbox"
      id={id}
      className="emp-perm-check mb-0"
      checked={checked}
      disabled={disabled}
      label={caption}
      aria-label={label}
      onChange={onChange}
    />
  );
}

function EmployeePermissionPanel({ permissions, disabled = false, onChange }) {
  const { tableClass, cardClass, buttonTableStyle } = useButtonTableStyle();
  const [query, setQuery] = useState("");
  const [uiFlags, setUiFlags] = useState({});

  const filteredItems = useMemo(() => {
    const q = query.trim().toLowerCase();
    const items = PERMISSION_CATALOG.flatMap((category) =>
      category.items.map((item) => ({
        ...item,
        pageLabel: item.label,
        groupLabel: category.label,
      })),
    );
    if (!q) return items;
    return items.filter(
      (item) =>
        item.pageLabel.toLowerCase().includes(q) ||
        item.groupLabel.toLowerCase().includes(q) ||
        String(item.hint || "")
          .toLowerCase()
          .includes(q),
    );
  }, [query]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const displayedItems = useMemo(() => {
    return filteredItems.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage,
    );
  }, [filteredItems, currentPage, itemsPerPage]);

  const handleItemsPerPageChange = (newSize) => {
    setItemsPerPage(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [query]);

  useEffect(() => {
    if (totalPages === 0 && currentPage !== 1) {
      setCurrentPage(1);
    } else if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const setItemFlag = (item, flag) => {
    if (disabled) return;
    const result = toggleItemAccess(permissions, uiFlags, item, flag);
    setUiFlags(result.uiFlags);
    onChange(result.permissions);
  };

  const setItemAllFlags = (item, nextVal) => {
    if (disabled) return;
    const result = setItemAllAccess(permissions, uiFlags, item, nextVal);
    setUiFlags(result.uiFlags);
    onChange(result.permissions);
  };

  const allPagesOn =
    filteredItems.length > 0 &&
    filteredItems.every((item) => {
      const access = getItemAccess(permissions, uiFlags, item);
      return access.edit && access.view && access.delete;
    });

  const setAllPagesFlags = (nextVal) => {
    if (disabled) return;
    let nextPerms = permissions;
    let nextUi = uiFlags;
    filteredItems.forEach((item) => {
      const result = setItemAllAccess(nextPerms, nextUi, item, nextVal);
      nextPerms = result.permissions;
      nextUi = result.uiFlags;
    });
    setUiFlags(nextUi);
    onChange(nextPerms);
  };

  return (
    <div>
      <div className="d-flex justify-content-between mb-3 flex-wrap gap-2">
        {/* <h5 className="mb-0 align-self-center">Permissions</h5> */}
        <input
          type="text"
          className={`form-control ${
            buttonTableStyle === "square" ? "rounded-0" : ""
          }`}
          style={{ maxWidth: "260px" }}
          placeholder="Search..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search permissions"
        />
      </div>

      {filteredItems.length === 0 ? (
        <p className="text-muted text-center py-4 mb-0">
          No pages match “{query}”.
        </p>
      ) : (
        <>
          <div className={`table-responsive mb-4 border ${cardClass}`}>
            <table
              className={`table text-nowrap mb-0 align-middle emp-perm-table ${tableClass}`}
            >
              <thead className="text-dark fs-4">
                <tr>
                  <th className="emp-perm-select-col">
                    <Form.Check
                      type="checkbox"
                      id="emp-perm-all-pages"
                      className={`emp-perm-header-check mb-0${allPagesOn ? " is-checked" : ""}`}
                      checked={allPagesOn}
                      disabled={disabled || filteredItems.length === 0}
                      aria-label="Select all page permissions"
                      onChange={() => setAllPagesFlags(!allPagesOn)}
                    />
                  </th>
                  <th>
                    <h6 className="fs-4 fw-semibold mb-0">Pages</h6>
                  </th>
                  <th>
                    <h6 className="fs-4 fw-semibold mb-0">Actions</h6>
                  </th>
                </tr>
              </thead>
              <tbody>
                {displayedItems.map((item) => {
                  const access = getItemAccess(permissions, uiFlags, item);
                  const allOn = Boolean(
                    access.edit && access.view && access.delete,
                  );
                  return (
                    <tr key={item.id}>
                      <td className="emp-perm-select-col">
                        <Form.Check
                          type="checkbox"
                          id={`emp-perm-${item.id}-all`}
                          className={`emp-perm-row-check mb-0${allOn ? " is-checked" : ""}`}
                          checked={allOn}
                          disabled={disabled}
                          aria-label={`${item.pageLabel} all permissions`}
                          onChange={() => setItemAllFlags(item, !allOn)}
                        />
                      </td>
                      <td>
                        <span className="fw-normal">{item.pageLabel}</span>
                      </td>
                      <td>
                        <div className="emp-perm-actions-group">
                          <AccessCheckbox
                            id={`emp-perm-${item.id}-edit`}
                            checked={Boolean(access.edit)}
                            disabled={disabled}
                            label={`${item.pageLabel} add edit`}
                            caption="Add / Edit"
                            onChange={() => setItemFlag(item, "edit")}
                          />
                          <AccessCheckbox
                            id={`emp-perm-${item.id}-view`}
                            checked={Boolean(access.view)}
                            disabled={disabled}
                            label={`${item.pageLabel} view`}
                            caption="View"
                            onChange={() => setItemFlag(item, "view")}
                          />
                          <AccessCheckbox
                            id={`emp-perm-${item.id}-delete`}
                            checked={Boolean(access.delete)}
                            disabled={disabled}
                            label={`${item.pageLabel} delete`}
                            caption="Delete"
                            onChange={() => setItemFlag(item, "delete")}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <Pagination
            totalItems={filteredItems.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </>
      )}
    </div>
  );
}

export default EmployeePermissionPanel;
